import React from 'react';
import { cn } from '@/utils/cn';
import { PageHeader } from './PageHeader';
import { ContentWrapper } from './ContentWrapper';
import type { BaseLayoutProps } from '@/types/layout.types';

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  title,
  subtitle,
  breadcrumbs,
  headerActions,
  className,
}) => {
  return (
    <div className={cn('min-h-screen bg-gray-50', className)}>
      <ContentWrapper>
        <PageHeader
          title={title}
          subtitle={subtitle}
          breadcrumbs={breadcrumbs}
          actions={headerActions}
        />
        {children}
      </ContentWrapper>
    </div>
  );
};

export default BaseLayout;